import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DeleteUsecase } from './delete-usecase';

@Component({
  selector: 'xcm-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
  standalone: false
})
export class ConfirmModalComponent {
  activeModal = inject(NgbActiveModal);

  deleteAsset = DeleteUsecase.ASSET;
  deleteAssetgroup = DeleteUsecase.ASSETGROUP;
  unlinkAssetgroup = DeleteUsecase.ASSETGROUP_UNLINK;
  @Input() usecase: DeleteUsecase;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {}

}
